module.exports = __webpack_public_path__ + "img/四川天府新区新兴小学.9251ef46.jpg";